export default "__VITE_ASSET__Dy6uQifh__"